import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import instagramFilled from '@iconify/icons-ant-design/instagram-filled';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { sentenceCase } from 'change-case';
import { isAdminUser } from '../../../../utils/adminUserTypes';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import { Box, Card, Grid, Avatar, Tooltip, Divider, Typography, IconButton,Button, LinearProgress,
  linearProgressClasses,
  Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, CircularProgress, 
  Skeleton} from '@material-ui/core';
// utils
import { fShortenNumber } from '../../../../utils/formatNumber';
//
import SvgIconStyle from '../../../SvgIconStyle';
import Label from 'src/components/Label';
import {
  PRESERVE_WHITESPACE_ELLIPSIS_SX,
  preserveWhitespaceTitle,
} from 'src/utils/preserveWhitespace';
import ViewProject from '../../../../pages/dashboard/ViewProject';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import moment from 'moment';
import { UserMoreMenu } from '../list';
import axios from 'axios';
import { REST_API_END_POINT, FacilityTypes } from 'src/constants/Defaultvalues';
import ConfirmationPopup from 'src/components/confirmationPopup';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { Stack } from 'immutable';
import { MChip } from 'src/components/@material-extend';
import FullScreenDialogsJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import { useSearchParams } from 'react-router-dom';
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import bellFill from '@iconify/icons-eva/bell-fill';
import QuickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { DialogAnimate } from 'src/components/animate';
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import { PictureAsPdf } from '@material-ui/icons';
// ----------------------------------------------------------------------

// const SOCIALS = [
//   {
//     name: 'Facebook',
//     icon: <Icon icon={facebookFill} width={20} height={20} color="#1877F2" />
//   },
//   {
//     name: 'Instagram',
//     icon: <Icon icon={instagramFilled} width={20} height={20} color="#D7336D" />
//   },
//   {
//     name: 'Linkedin',
//     icon: <Icon icon={linkedinFill} width={20} height={20} color="#006097" />
//   },
//   {
//     name: 'Twitter',
//     icon: <Icon icon={twitterFill} width={20} height={20} color="#1C9CEA" />
//   }
// ];

const option = [
  { id: 0, value: 'Inactive' },
  { id: 1, value: 'New' },
  { id: 2, value: 'In Progress' },
  { id: 3, value: 'Completed' },
  { id: 4, value: 'Hold' },
  { id: 5, value: 'Accepted' },
  { id: 6, value: 'Rejected' },
  { id: 7, value: 'Verified' },
  { id: 6, value: 'Reopen' },
  { id: 9, value: 'Rejected' },
]
const colors = [
  'error',
  'primary',
  'secondary',
  'success',
  'warning',
  'success',
  'error',
  'success',
  'error',
  'error',
]

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
     WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  }
}));

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  // background: `url(${src}) center/cover no-repeat`
});

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography variant="caption" sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}>
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  );
}

// UserCard.propTypes = {
//   user: PropTypes.object.isRequired
// };

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 25,
  height: 28,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '5px',
  color: theme.palette.success.main,
  // backgroundColor: alpha(theme.palette.success.main, 0.16),
}));

export default function UserCard({ user, handleClickOpenViewPage, setRenderCards, medal, setIsEdit, openViewPage,removePopupData, setOpenViewPage,projectId, setProjectId,projectName,setProjectName, handleFetchEditData,currentTab,handleCheckboxChange,renderCards,communityJob,communityJobsListState,JobNewCard}) {
  const communityJobNavigateState = {
    fromCommunityJob: true,
    ...(communityJobsListState ? { communityJobsListState } : {}),
  }
  console.log('JobNewCard',JobNewCard)
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  // const [searchParams, setSearchParams] = useSearchParams();
  const currentDateUnix = moment();
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));
  console.log('user==========',user);
  const { name, due_date,installation_date,installation_start_date,installation_end_date, id, status,cover_image, noServiceNoTask, member_count, task_count, job_note_count, img, logo='https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg' ,progressValue,hold,jobcost,job_category_name,job_class_name, community_name, customer_name,allInstallationCompleted,InstallCompleteStatus,attachment,isFromDesignOrder,doc_number,syncWithQuickbooks,est_doc_number,installation_acceptance ,request_id, request_status, is_split_order, for_parent_facility, origin_facility_id,customer_logo, installation_pending_review, approved_pdf, tm_review_draft, finalize_invoice,rush } = user;                 
  const isSalesOrderVoided = Number(request_status) === 10;
  const showVoidMutedStyle = isSalesOrderVoided;
  const [isDelete,setIsDelete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  const [pdfLoading, setPdfLoading] = useState(true);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);
  // const [openViewPageTemp, setOpenViewPageTemp] = useState(false);
  // const [openViewPage, setOpenViewPage] = useState(openViewPageTemp?openPopupTemp:false||false);

  // const [projectName,setProjectName]=useState('')
  // const [projectId, setProjectId] = useState('');
  const filteredAttachments = attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
  let userData = JSON.parse(localStorage.getItem('user'))
  const CompletedStatus = InstallCompleteStatus ===1? 'Installed' : InstallCompleteStatus === 2 ? 'Picked Up':InstallCompleteStatus === 3? 'Shipped' : 'Completed'
  // installation_pending_review: show "Installation In Review" only when explicitly 1 (Installation tab); avoid when 0/null
  const isPendingReview = Number(installation_pending_review) === 1 && allInstallationCompleted && !installation_acceptance
  const displayStatusLabel = isPendingReview ? 'Completed' : CompletedStatus
  // const displayStatusColor = isPendingReview ? 'warning' : 'success'
  const displayStatusColor = 'success'
  const isTMReviewCard = currentTab === 'T & M Review';
  const tmCardStatusLabel = Number(tm_review_draft || 0) === 1
    ? 'Draft'
    : Number(tm_review_draft || 0) === 0 && Number(finalize_invoice || 0) === 1 && Number(installation_acceptance || 0) !== 1
      ? 'Invoiced'
      : Number(tm_review_draft || 0) === 0 && Number(finalize_invoice || 0) === 0
        ? 'Ready to Invoice'
        : 'Draft';
  const tmCardStatusColor = tmCardStatusLabel === 'Draft'
    ? 'warning'
    : tmCardStatusLabel === 'Invoiced'
      ? 'info'
      : 'success';
  const explodedPermissions =userData?.exploded_permissions
  const handleDeleteTask = (status)=>{
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user')
      let newStatus = 0
      if ( status === 0 ){
        newStatus = 1
      }else if ( status === 2 ){
        newStatus = 2
      }else{
        newStatus = 0
      }
      axios.post(`${REST_API_END_POINT}project/delete-project`,{ id: Number(id), status: newStatus },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4 || response.data.status === 2 || response.data.status === 1){
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setRenderCards(true)
          // navigate(PATH_DASHBOARD.project.viewproject+projectId)
        }else if(response.data.status === 5 || response.data.status === 3 || response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-job-hold-status`,
        {
          projectId: Number(id),
          userId: user.user_id,
          request_id: request_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const isPdfUrl = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('application/pdf');
  }
  const DESIGN_PREVIEW_EXTENSIONS = ['eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps', 'indd', 'indt', 'x-eps', 'x-ai', 'postscript'];
  const getFileExtensionFromUrl = (url) => {
    if (!url) return '';
    const clean = url.split('?')[0];
    return clean.includes('.') ? clean.split('.').pop().toLowerCase() : '';
  };
  const isGoogleViewerDesign = (url, fileType = '', extension = '') => {
    const extFromUrl = getFileExtensionFromUrl(url);
    const ext = String(extension || '').toLowerCase();
    const ft = String(fileType || '').toLowerCase();
    const mimeSubtype = ft.includes('/') ? ft.split('/').pop() : ft;
    return (
      DESIGN_PREVIEW_EXTENSIONS.includes(extFromUrl) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(ext) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(mimeSubtype)
    );
  };

  return (
   <>
      <Card sx={{
        transition: 'transform 0.2s',
        cursor: 'pointer',
        ml: 2,
        '&:hover': {
          transform: 'scale(1.02)',
        },
        ...(showVoidMutedStyle && {
          position: 'relative',
          backgroundColor: theme.palette.mode === 'light'
            ? alpha(theme.palette.grey[500], 0.14)
            : alpha(theme.palette.grey[600], 0.28),
          filter: 'grayscale(75%)',
          opacity: 0.68,
          '&::after': {
            content: '"VOID"',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-10deg)',
            color: theme.palette.error.main,
            fontWeight: 800,
            fontSize: '20px',
            letterSpacing: '2px',
            zIndex: 10,
            opacity: 0.4,
            pointerEvents: 'none',
          },
        }),
          border: is_split_order ? 
            `1px solid ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}` : 'none',
          boxShadow: is_split_order ? 
            `0 -2px 8px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}40, 0 4px 12px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}30, 0 2px 6px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
              theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
              theme.palette.grey[500]}20` : 'none',
      }}
      onClick={() => {
        if(communityJob){
          navigate(PATH_DASHBOARD.project.viewproject+id, { state: communityJobNavigateState })
        }else{
        handleClickOpenViewPage(id,name)
        }
      }}
        >
        <Box sx={{ position: 'absolute', top: 8, left: 8, zIndex: 10, padding: '12px' }}>
        {currentTab === 'Post Production'? <Checkbox
              onChange={(e) => handleCheckboxChange(user.id, e.target.checked,user)}
            />
            :
            <img width={25} height={25} src={medal}/>
            }
          
          {/* {jobcost===1?<MChip label="Hold" color="warning" ></MChip>:""} */}
          {/* {jobcost===1?<Label variant="filled" color="warning">Hold</Label>:""} */}
          
          
        </Box>
        {/* {job_category_name=='Time & Material' ? 
          <Box sx={{ position: 'absolute', top: 8, left: '40%', zIndex: 10, padding: '12px' }}> 
            <Label variant='filled' color="info">T&M</Label>
          </Box>
        :''} */}
        {
          JobNewCard ? 
          <Box sx={{ position: 'absolute', top: 8, left: '20%', zIndex: 10, padding: '12px' }}> 
          <Label variant="filled">
            <IconWrapperStyle>
              <Icon width={20} height={20} icon={briefcaseFill} />
            </IconWrapperStyle>
            New
          </Label>
        </Box> :''
        }
        <Box sx={{ position: 'absolute', top: 2, left: '55%', zIndex: 10,  }}> 
          {hold===1?<Label variant="filled" color="warning">Hold</Label>:""}
          {currentTab === 'Post Production'? <img width={25} height={25} src={medal}/> : ""}
        </Box>
        <Box sx={{ position: 'absolute',top: {xs: 100, sm: 100, md: 90, lg: 90, xl: 100 }, left: 12, zIndex: 10,display:"flex",justifyContent:"space-between" }}>
          {jobcost === 1 ?
            <Tooltip title="Material Out of Stock">
              <Typography>
                <Label variant='filled' color="error">Material Out of Stock</Label>
              </Typography>
            </Tooltip>
          : ""}
        </Box>
           {rush ? 
          //  {xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }
        <Box sx={{ position: 'absolute',cursor:'pointer',top: 2, left: "30%", zIndex: 10 ,  }}>   
            <Typography >
              <Label variant='filled' color="error">Rush</Label>
            </Typography> 
        </Box> : '' }
        {job_class_name ? 
        <Box sx={{ position: 'absolute',cursor:'pointer',top: {xs: 100, sm: 100, md: 90, lg: 90, xl: 100 }, right: 6, zIndex: 10 }}>
          <Tooltip title={`Job Class: ${job_class_name}`}>
            <Typography >
              <Label variant='filled' color="secondary">{job_class_name}</Label>
            </Typography>
          </Tooltip>
        </Box> : '' }
        {job_category_name ? 
        <Box sx={{ position: 'absolute',cursor:'pointer', top: {xs: 70, sm: 70, md: 60, lg: 60, xl: 70 }, right: 6, zIndex: 10 }}>
          <Tooltip title={`Job Type: ${job_category_name}`}>
          <Typography>
          <Label variant='filled' color="info">{job_category_name}</Label>
          </Typography>
          </Tooltip>
          </Box> : '' }
        <Typography
          sx={{
            position: "absolute",
            cursor: "pointer",
            top: { xs: 70, sm: 70, md: 60, lg: 60, xl: 70 },
            left: 12,
            zIndex: 10,
            maxWidth: 120, // adjust
          }}
        >
          <Tooltip title={isSalesOrderVoided
            ? 'Void'
            : (isTMReviewCard
            ? tmCardStatusLabel
            : (isPendingReview
              ? displayStatusLabel
              : option.find(opt => opt.id === status)?.value))} arrow>
            <span style={{ display: "inline-block", maxWidth: 110 }}>
              <Label
                variant={theme.palette.mode === "light" ? "filled" : "filled"}
                color={isSalesOrderVoided ? 'error' : (isTMReviewCard ? tmCardStatusColor : (isPendingReview ? displayStatusColor : colors[status]))}
                sx={{
                  height: 24,
                  lineHeight: "24px",
                  px: 1.2,
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '12px',
                    display: 'inline-block',
                    maxWidth: 75,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'middle',
                  }}
                >
                  {isSalesOrderVoided
                    ? 'Void'
                    : (isTMReviewCard
                    ? tmCardStatusLabel
                    : (isPendingReview
                      ? displayStatusLabel
                      : option.find(opt => opt.id === status)?.value))}
                </Typography>
              </Label>
            </span>
          </Tooltip>
        </Typography>
        <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 20, padding: '12px', display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Job Notes Notification Icon - Left of UserMoreMenu */}
        {job_note_count > 0 && (
          <Tooltip title={`${job_note_count} note${job_note_count > 1 ? 's' : ''}`}>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#ff4444',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                animation: 'pulse 2s infinite',
                '@keyframes pulse': {
                  '0%': {
                    boxShadow: '0 0 0 0 rgba(255, 68, 68, 0.7)',
                  },
                  '70%': {
                    boxShadow: '0 0 0 10px rgba(255, 68, 68, 0)',
                  },
                  '100%': {
                    boxShadow: '0 0 0 0 rgba(255, 68, 68, 0)',
                  },
                },
              }}
            >
              <Icon width={14} height={14} icon={bellFill} />
            </Box>
          </Tooltip>
        )}
        {/* <IconButton
            sx={{
              color: (theme) => theme.palette.common.white, 
              '&.Mui-checked': {
                color: (theme) => theme.palette.common.white 
              }
            }}
            aria-controls="simple-menu"
            aria-haspopup="true"
            // onClick={handleClick}
            size="small"
          >
             <Icon  icon={moreVerticalFill} width={20} height={20} />
          </IconButton> */}
         {(userData?.user_type !=3 && currentTab!="Completed" ) && for_parent_facility !== 2 && 
         <UserMoreMenu hold={hold} text={status === 0 ? 'Activate' : null} 
          {...((currentTab!="Installations" && currentTab!="Completed" && currentTab!="Hold") ? {
            onDeactivate: ()=>{
            if(explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))){
              handleDeleteTask(status)
            }else{
              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
            }
          }} : {})}
          onDelete={()=>{
            if(explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))){
              setIsDelete(true);
            }else{
              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
            }
          }}
          {...((currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' && currentTab != 'Completed' && status != 3 ) ? { 
            onHold:()=>{
            if(explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))){
              setOpenHoldPopup(true);
            }else{
              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
            }
          }} : {})}
          // {...(status !== 3 ? {
          //   onEdit: () => {
          //     if(explodedPermissions?.some(permission => ['Edit Jobs'].includes(permission))){
          //       setIsEdit(true);
          //       handleFetchEditData(id);
          //     }else{
          //       enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
          //     }
          //   }
          // } : {})} 
          />}
        </Box>
        <CardMediaStyle sx={{cursor:'pointer'}} 
        onClick={()=>handleClickOpenViewPage(id,name)}
      //   onClick={()=>{
      //   //  navigate(PATH_DASHBOARD.project.viewproject + id, { state: { currentTab:currentTab } });
        
  
      // }}
      >
       
        {/* <IconButton
          sx={{
            top: 8,
            right: 8,
            position: 'absolute'
          }}
        >
          <Icon icon={moreVerticalFill} width={20} height={20} />
        </IconButton> */}
          {/* <SvgIconStyle
            color="paper"
            src="/static/icons/shape-avatar.svg"
            sx={{
              width: 144,
              height: 62,
              zIndex: 10,
              bottom: -26,
              position: 'absolute'
            }}
          /> */}
          {/* <Avatar
            alt={name}
            src={img}
            sx={{
              width: 64,
              height: 64,
              zIndex: 11,
              position: 'absolute',
              transform: 'translateY(-50%)'
            }}
          /> */}
          {(() => {
            const imageUrl = approved_pdf ? approved_pdf : customer_logo ? customer_logo : (filteredAttachments?.length >0) ? filteredAttachments[0]?.name : (cover_image && cover_image !== 'DefaultThumbnailURL') ? cover_image : logo;
            const attachmentType = filteredAttachments?.length > 0 ? filteredAttachments[0]?.file_type : '';
            const attachmentExt = filteredAttachments?.length > 0 ? filteredAttachments[0]?.extension : '';
            const isPdf = isPdfUrl(imageUrl);
            const isDesignPreview = isGoogleViewerDesign(imageUrl, attachmentType, attachmentExt);

            if (isPdf) {
              return (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                  }}
                >
                  <Tooltip title="View PDF">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setPdfLoading(true);
                        setSelectedPDF(imageUrl);
                        setOpenPDFModal(true);
                        setUseOfficeViewer(true);
                      }}
                      aria-label="open pdf"
                      sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 15,
                        color: theme.palette.error.main,
                        backgroundColor: theme.palette.text.primary,
                      }}
                    >
                      <PictureAsPdf style={{ fontSize: 30 }} />
                    </IconButton>
                  </Tooltip>
                  <iframe
                    src={imageUrl}
                    title={imageUrl}
                    style={{
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                    }}
                    frameBorder="0"
                  />
                </Box>
              );
            }
            if (isDesignPreview) {
              return (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 8,
                  }}
                >
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(imageUrl)}&embedded=true`}
                    title={imageUrl}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 'none', pointerEvents: 'none' }}
                  />
                </Box>
              );
            }
            return (
              <CoverImgStyle src={imageUrl} />
            );
          })()}
          {/* <CoverImgStyle alt="cover" src={customer_logo ? customer_logo : (filteredAttachments?.length >0) ? filteredAttachments[0]?.name : (cover_image && cover_image !== 'DefaultThumbnailURL') ? cover_image : logo} /> */}
          
        </CardMediaStyle>
        <Grid container sx={{cursor:'pointer', mt: 0.5, textAlign: 'center',justifyContent:'space-between' ,display:'flex',flexDirection:'row',px:2 }}>
          <Typography>
            <Label
              variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
              color="secondary"
            >
              <Tooltip title={
                is_split_order && for_parent_facility == 1 
                  ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                  : customer_name || ''
              }>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 60, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {is_split_order && for_parent_facility == 1 
                      ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                      : customer_name || ''
                    }
                  </span>
                </Typography>
              </Tooltip>
            </Label>
          </Typography>
          <Typography>
            {
              community_name ? 
            <Label
              variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
              color="default"
            >
              <Tooltip title={community_name}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    maxWidth: 60, // Adjust as necessary
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {community_name}
                  </span>
                </Typography>
              </Tooltip>
            </Label> : ''
            }
          </Typography>
        </Grid>
        {/* <Typography style={{cursor:'pointer'}} onClick={()=>{
         navigate(PATH_DASHBOARD.project.viewproject+id, { state: { currentTab:currentTab } })
      }} variant="subtitle1" align="center" sx={{ mt: 2 }}>
          {name}
        </Typography> */}
        <Grid container sx={{cursor:'pointer', py: 1, textAlign: 'center',justifyContent:'space-between' ,display:'flex',flexDirection:'row',px:2 }}>
        <Tooltip title={preserveWhitespaceTitle(name)}>
          <Typography
            variant="subtitle1"
            align="center"
          //   onClick={()=>{
          //     navigate(PATH_DASHBOARD.project.viewproject+id, { state: { currentTab:currentTab } })
          //  }}
          onClick={()=>{
            if(communityJob){
              navigate(PATH_DASHBOARD.project.viewproject+id, { state: communityJobNavigateState })
            }else{
            handleClickOpenViewPage(id,name)
            }
          }}
          
            sx={{
              alignItems:'center',
              justifyContent:'center',
              cursor: 'pointer',
              display: 'flex',
              maxWidth: 100, // Adjust as necessary
              ...PRESERVE_WHITESPACE_ELLIPSIS_SX,
              color: 'primary.main',
            }}
          >
            <span style={PRESERVE_WHITESPACE_ELLIPSIS_SX}>
              {name}
            </span>
          </Typography>
        </Tooltip>
        {
          for_parent_facility == 2 ? '' :
            <Typography variant='subtitle2'>{` Members: ${member_count}`}</Typography>
        }
        </Grid>
      
  
        <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: syncWithQuickbooks ? 'space-between' : 'center',
              alignItems: 'center',
              // my: 2,
              px: 1, mb: 1,
            }}
          >
          {/* {syncWithQuickbooks ? (
          <Box sx={{ display: 'flex' }}>
              <img
                src={QuickbookLogo}
                width={'50px'}
                height={'25px'}
              />
              <Typography >
                {doc_number ? `#${doc_number}` : ''}
              </Typography>
            </Box>
          ) : (
            ''
          )} */}
           {syncWithQuickbooks ? (
                      <Box sx={{ display: 'flex' , alignItems: 'center', mb: 1}}>
                        <img
                          src={QuickbookLogo}
                          width={'50px'}
                          height={'25px'}
                          style={{ marginTop: '10px' }}
                        />
                       
                       <Box sx={{ display: "flex", flexDirection: "column", }}>
                       
                            {
                          (installation_acceptance && est_doc_number) && (doc_number !==est_doc_number)?
                          <>
                            <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {est_doc_number ? `Job No: #${est_doc_number}` : ''}
                        </Typography>
                              <Typography sx={{ marginTop: '1px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Inv No: #${doc_number}` : ''}
                        </Typography>
                        </>
                          :
                          est_doc_number == null ?
                          <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Inv No: #${doc_number}` : ''}
                        </Typography>
                        :
                           <Typography sx={{ marginTop: '13px',color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90"}}>
                          {doc_number ? `Job No: #${doc_number}` : ''}
                          
                        </Typography>
                        }
                        </Box>
                      </Box>
                    ) : (
                      ''
                    )}
          

        <Typography variant="body2" align="center" >
          {(status!==3&& moment.unix(installation_date).isBefore(currentDateUnix))?(
           <Label 
              variant={theme.palette.mode === 'light' ? 'filled' : 'filled'}
              color={'error'}
              >
               Overdue:{installation_start_date && installation_end_date 
                 ? `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
                 : moment.unix(installation_date).format('MM/DD/YYYY')
               }
           </Label>
           ):(
           <>
          Date:{installation_start_date && installation_end_date 
            ? `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
            : moment.unix(installation_date).format('MM/DD/YYYY')
          }
          </>
          )}
        </Typography>
        {/* {isAdminUser (userData.user_type) && <Button onClick={() => {
                              navigate(PATH_DASHBOARD.project.jobCost+'/'+id)
                            }} sx={{ borderRadius: 20,marginBottom:1 }} variant="outlined">
                    Job Cost
                  </Button>} */}
                  
      </Box>
        {isAdminUser (userData.user_type) ?<>
          <Typography variant="body2"   style={{display:"flex", flexDirection:"column" ,alignItems:"center"}}>Job Cost</Typography>
          <Box sx={{ width: '100%', mr: 1 }}>
          
          <BorderLinearProgress variant="determinate" value={progressValue} />
        </Box>
       <Box sx={{ minWidth: 35, px: 1 }}>  
         <Typography variant="body2">{`${Math.round(
           progressValue,
         )}%`}</Typography>
       </Box>
       </>:""}
  
        {/* <Divider />
        
        <Grid container sx={{cursor:'pointer', py: 1.5, textAlign: 'center',justifyContent:'space-between' ,display:'flex',flexDirection:'row',px:2, }}
        onClick={()=>{
          navigate(PATH_DASHBOARD.project.viewproject+id)
       }}>
          <Typography>
          <Label
            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
             color={isPendingReview ? displayStatusColor : colors[status]} >
             {isPendingReview ? displayStatusLabel : option.find(opt=>opt.id===status).value}
            </Label>
          </Typography>
          <Typography variant='subtitle2'>
          {(status!==3&& moment.unix(installation_date).isBefore(currentDateUnix))?(
           <Label 
              variant={theme.palette.mode === 'light' ? 'ghost' : 'outlined'}
              color={'error'}
              >
               {`Overdue Tasks: ${task_count}`}
           </Label>
           ):(
           <>
              {` Tasks: ${task_count}`}
          </>
          )}
            {` Tasks:${task_count}`}
            </Typography>
            <Typography variant='subtitle2' sx={{ mt: 1 }}>{` Members: ${member_count}`}</Typography>
        </Grid> */}
        {/* <Grid container sx={{cursor:'pointer',px:2, mb: 1.5, }}
        onClick={()=>{
          navigate(PATH_DASHBOARD.project.viewproject+id)
       }}>
          <Typography variant='subtitle2'>{` Members: ${member_count}`}</Typography>
        </Grid> */}
        {/* <Grid container sx={{paddingBottom:1, textAlign: 'center',justifyContent:'center'  }}>
        <Typography>{` Members:${member_count}`}</Typography>
        </Grid> */}
        {/* <ConfirmationPopup open={isDelete} handleClick={()=>handleDeleteTask(status)} message={'Want to Deactivate This Project'} handleClose={()=>setIsDelete(false)}/> */}
        <div onClick={(e) => e.stopPropagation()}>
          <ConfirmationPopup
            open={isDelete}
            handleClick={()=>handleDeleteTask(2)}
            handleClose={() => { setIsDelete(false) }}
            message={'You want to delete this Job. This action will also permanently delete the associated Sales Order and any related data.'}
            // message={'You want to delete this Job. The related Offical Request will also get deleted.'}
          />
        </div>
        <Dialog
          open={openHoldPopup}
          onClose={(e) => {
            e.stopPropagation(); 
            setOpenHoldPopup(false);
            setHoldReason('');
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{ invisible: true }}
        >
          <DialogTitle id="alert-dialog-title">
            {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {hold === 1
                ? 'You want to move this Job from Hold.'
                : 'You want to move this Job to Hold.'}
            </DialogContentText>
            {(hold === 0) ? (
              <TextField
                sx={{ width: 400 }}
                label="Reason"
                type="text"
                multiline
                minRows={3}
                maxRows={7}
                value={holdReason}
                onChange={(e) => {
                  setHoldReason(e.target.value);
                  if (holdReasonError) setHoldReasonError('');
                }}
                error={Boolean(holdReasonError)}
                helperText={holdReasonError}
              />
            ) : ''}
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              variant="contained"
              onClick={async (e) => {
                e.stopPropagation(); 
                if ((hold === 0) && !holdReason.trim()) {
                  setHoldReasonError('Reason is required to put this Job on Hold.');
                  return;
                }

                setIsSubmittingHold(true);
                await handleUpdateHoldStatus(holdReason);
                setIsSubmittingHold(false);
                setOpenHoldPopup(false);
                setHoldReason('');
                setHoldReasonError('');
              }}
              disabled={isSubmittingHold}
            >
              {isSubmittingHold ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                'OK'
              )}
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation(); 
                setOpenHoldPopup(false);
                setHoldReason('');
              }}
              sx={{ color: theme.palette.error.main }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <DialogAnimate open={openPDFModal} onClose={(e) => { e.stopPropagation(); setOpenPDFModal(false)}}>
          <Card sx={{ padding: 3, maxWidth: 768, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '90%', display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', marginLeft: '25px' }}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                    // For other users: Open PDF normally
                    window.open(selectedPDF, '_blank');
                }}
                disabled={!selectedPDF}
                startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                sx={{
                  fontSize: '14px'
                }}
              >
                View PDF
              </Button>
            </div>
            {pdfLoading && (
              <Skeleton variant="rectangular" width="100%" height={500} />
            )}
              <iframe
                src={selectedPDF}
                title="Selected PDF"
                width="100%"
                height="500px"
                frameBorder="0"
                style={{ display: pdfLoading ? 'none' : 'block' }}
                onLoad={() => setPdfLoading(false)}
              />
          </Card>
        </DialogAnimate>
      </Card>
   </>
  );
}
